import {
  Container,
  Heading,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";

export default function () {
  return (
    <Container maxW="container.lg">
      <Heading size="3xl">About Us</Heading>
      <Text pt="32px">
        Panwellz has always been a fan of destruction. Unfortunately, many forms
        of property destruction are not (usually) legal in the normal world, so
        he had to settle for Roblox. Although it wasn't all bad as he was still
        able to profit from it.
      </Text>
      <br />
      <Text pt="8px">
        Since the creation of Car Crushers, we have accepted no outside funding
        whatsoever, and we do not plan on ever accepting such in the future. Nor
        have we ever utilized gambling or other predatory tactics for profit.
      </Text>
      <br />
      <Heading pt="16px">Customer Support</Heading>
      <UnorderedList px="8px">
        <ListItem>
          Discord:{" "}
          <Link color="#646cff" href="https://discord.com/invite/carcrushers">
            Join the server
          </Link>{" "}
          and open a ticket with ModMail.
        </ListItem>
        <ListItem>
          Forum:{" "}
          <Link color="#646cff" href="https://ccdiscussion.com/">
            Make a post on our forum.
          </Link>
        </ListItem>
      </UnorderedList>
      <br />
      <Heading pt="16px">Company Information</Heading>
      <Text>
        <b>Wells Studios AB</b>
        <br />
        Västerås, Västmanland
        <br />
        Reg no: 559206-0452
        <br />
        <Link color="#646cff" href="https://discord.com/invite/carcrushers">
          https://discord.com/invite/carcrushers
        </Link>
      </Text>
    </Container>
  );
}
